import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with a toggle "show/hide" eye icon on the right.
 * Props: value, onChange, required, minLength, placeholder, dataTestId, className
 */
export default function PasswordInput({
  value,
  onChange,
  required = false,
  minLength,
  placeholder,
  dataTestId,
  className = "",
  autoComplete = "current-password",
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        required={required}
        minLength={minLength}
        placeholder={placeholder}
        autoComplete={autoComplete}
        data-testid={dataTestId}
        className={`w-full pr-11 py-3 border border-emerald-900/10 rounded-xl text-sm outline-none focus:border-primary ${className}`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        data-testid={dataTestId ? `${dataTestId}-toggle` : "password-toggle"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-primary transition"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
